import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import { GalleryPlugin } from "@photo-sphere-viewer/gallery-plugin";
import { MapPlugin } from "@photo-sphere-viewer/map-plugin";
import "@photo-sphere-viewer/markers-plugin/index.css";
import "@photo-sphere-viewer/virtual-tour-plugin/index.css";
import "@photo-sphere-viewer/gallery-plugin/index.css";
import { useRef, useState } from "react";
import { renderToStaticMarkup } from 'react-dom/server';
import CustomPanelContent from "./Component/CustomPanelContent";
import CustomMarker from "./Component/CustomMarker";
import data from "./data";

function Viewer () {

  const [currentPanorama, setCurrentPanorama] = useState('assets/compressed/living-room-360.jpeg');
  const currentPanoramaId = useRef();
	const pSRef = useRef();
  const pSRefCore = useRef();
  
  let markersPlugin = null;

  const renderPanelString = (data) => {
    return data.map(d =>
      renderToStaticMarkup(
        <CustomPanelContent
          id={d.id}
          url={d.url}
          file={d.file}
          img={d.img}
          longText={d.longText}
        />
      )
    )
  }

  const renderMarkerString = (data) => {
    return data.map(d =>
      renderToStaticMarkup(
        <CustomMarker
          id={d.id}
          icon={d.icon}
          img={d.img}
          name={d.name}
          type={d.type}
        />
      )
    )
  }
  
  const infoMarkerStringArr = renderMarkerString(data.infoMarkersData)
  const roomMarkerStringArr = renderMarkerString(data.roomMarkersData)
  const panelContentStringArr = renderPanelString(data.panelContentsData)

  const togglePanel = (id, panelContent) => {
    if (pSRefCore.current.panel.isVisible(id)) {
      pSRefCore.current.panel.hide();
    } else {
      pSRefCore.current.panel.show({
        id: id,
        width: '25%',
        content: panelContent,
      });
    }
  }

  const handleReady = (instance) => {
    pSRefCore.current = instance;
    const viewer = pSRef.current

		// initialize plugins 
		markersPlugin = instance.getPlugin(MarkersPlugin);
    const galleryPlugin = instance.getPlugin(GalleryPlugin);
    const mapPlugin = instance.getPlugin(MapPlugin);

    if (!markersPlugin) return;

    // map plugin
    mapPlugin.addEventListener('select-hotspot', ({ hotspotId }) => {
      let id = hotspotId + "-marker"

      let roomMap = data.roomMarkerMapData.find(item => item.id === id)
      
      // set center from hotspots
      let newHotspotCenter = data.mapData[0].hotspots.find(item => item.id === hotspotId)
      console.log(mapPlugin.config.center)
      mapPlugin.setOptions({
        center: {
          x: newHotspotCenter.x,
          y: newHotspotCenter.y
        }
      })

      console.log(mapPlugin)
      
      currentPanoramaId.current = id
      setCurrentPanorama(roomMap.panorama)
      viewer.setPanorama(roomMap.panorama)
    });

    // gallery plugin
    galleryPlugin.setItems(data.galleryData)
    pSRefCore.current.addEventListener('panorama-load', (panorama) => {
      mapPlugin.close()
      let roomMap = data.roomMarkerMapData.find(item => item.panorama == panorama.panorama)
      
      markersPlugin.clearMarkers()
      let markers = roomMap.markers.map(item => {
        let pairData = null
        let pairArr = null 
        if(item.data.type == "info"){
          pairData = data.infoMarkersData
          pairArr = infoMarkerStringArr
        }
        else if (item.data.type == "room"){
          pairData = data.roomMarkersData
          pairArr = roomMarkerStringArr
        }
        let pairIndex = pairData.findIndex(pair => pair.id == item.html)
        return {
          ...item,
          html: pairArr[pairIndex] 
        }
      })
      markers.forEach(marker => markersPlugin.addMarker(marker));
    })

    markersPlugin.addEventListener("select-marker", (e) => {
      const id = e.marker.config.id
      const type = e.marker.config.data.type

      if (type == "info") {
        if(infoMarkerStringArr.find(item => item.id === data.infoMarkersData.id)) {
          let panelContentIdx = data.panelContentsData.findIndex(item => item.marker === id)
          togglePanel(id, panelContentStringArr[panelContentIdx]);
        }
      }

      if (type == "room") {
        let roomMap = data.roomMarkerMapData.find(item => item.id === id)
        currentPanoramaId.current = id
        setCurrentPanorama(roomMap.panorama)
        viewer.setPanorama(roomMap.panorama)
      }
    });

  
  };

  const markersInit = data.roomMarkerMapData[0].markers.map(item => {
    let pairData = null
    let pairArr = null 
    if(item.data.type == "info"){
      pairData = data.infoMarkersData
      pairArr = infoMarkerStringArr
    }
    else if (item.data.type == "room"){
      pairData = data.roomMarkersData
      pairArr = roomMarkerStringArr
    }
    
    let pairIndex = pairData.findIndex(pair => pair.id == item.html)

    return {
      ...item,
      html: pairArr[pairIndex] 
    }
  })



	// declare plugins
  const plugins = [
    [
			MarkersPlugin, 
			{
        markers: markersInit 
			}
		],
    [
      GalleryPlugin,
    ],
    [
      MapPlugin,
      data.mapData[0]
    ]
  ];


  return (
    <div className="App" id={"container-360"}>
      <ReactPhotoSphereViewer
        ref={pSRef}
        loadingImg= {"assets/loading.gif"}
        name=""
        defaultYaw={"0deg"}
        navbar={[
          "zoom",
          "move",
          "gallery",
          "download",
          "caption",
          "fullscreen",
        ]}
        height={"100vh"}
        width={"100%"}
        hideNavbarButton={true}
        onReady={(instance) => {
          handleReady(instance)
        }}
        defaultZoomLvl="0"
        plugins={plugins}
        container={"container-360"}
        src={currentPanorama}
      ></ReactPhotoSphereViewer>
    </div>
  );
}

export default Viewer;